// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xobN0","title":"Header_title__2yiJ8","side":"Header_side__OLcCP"};